import { VscDebugStart } from "react-icons/vsc";
import { motion } from "framer-motion";

export default function Home() {
  return (
    <div
      id="home"
      className="overflow-hidden w-full flex flex-col lg:flex-row justify-center items-center lg:space-x-24 space-y-10 lg:space-y-0 bg-gradient-to-r from-red-300 to-red-900 mt-20 px-4 lg:px-0 py-10 min-h-[80vh] lg:min-h-[90vh] relative"
    >
      {/* Left Section - Text Content */}
      <div className="text-center lg:text-left max-w-[500px] z-10">
        <motion.div
          whileHover={{ scale: 1.06 }}
          transition={{ type: "spring", stiffness: 300, damping: 20 }}
          className="inline-block"
        >
          <h1 className="font-serif text-4xl lg:text-5xl font-bold leading-tight text-black">
            PEST'S OUT WHEN
            <br className="hidden sm:block" />
            <span className="lg:inline"> </span>
            SAI SUCHITH IN
          </h1>
        </motion.div>
        <p className="font-semibold text-base lg:text-lg mt-5 text-black">
          Discover your next great adventure.
        </p>
      </div>

      {/* Right Section - Image and Floating Elements */}
      <div className="relative w-fit max-w-full mx-auto z-0">
        {/* Main Image with popup effect */}
        <motion.img
          whileHover={{ scale: 1.08, boxShadow: "0 8px 32px rgba(0,0,0,0.25)" }}
          transition={{ type: "spring", stiffness: 300, damping: 20 }}
          src={require("./Pest-20.jpg")}
          alt="Pest Control Service"
          className="border rounded-3xl object-cover bg-white w-[280px] h-[230px] sm:w-[350px] sm:h-[350px] lg:w-[470px] lg:h-[420px] lg:pt-[30px] max-w-full cursor-pointer"
        />

        {/* Floating Logos */}
        <img
          src={require("./About-2.png")}
          alt="Company Logo 1"
          className="absolute top-[60px] left-0 sm:left-[-30px] w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] lg:w-[100px] lg:h-[100px] hidden sm:block"
        />
        <img
          src={require("./About-3.png")}
          alt="Company Logo 2"
          className="absolute top-[80px] right-0 sm:right-[-30px] w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] lg:w-[100px] lg:h-[100px] hidden sm:block"
        />

        {/* Emergency Call Box */}
        <motion.div
          className="mt-[-10px] ml-auto mr-0 border rounded-3xl bg-white text-center shadow-lg p-3 h-[10vh] sm:h-[12vh] w-[30vh] sm:w-[35vh]"
          initial={{ opacity: 0, x: 150 }}
          whileInView={{ opacity: 1, x: 7 }}
          transition={{ duration: 1 }}
          viewport={{ once: false, amount: 0.1 }}
        >
          <h1 className="font-bold text-sm sm:text-base">Emergency Call</h1>
          <span className="text-lg sm:text-2xl text-red-500 font-bold">
            +91 98459 88061
          </span>
        </motion.div>

        {/* Intro Video Box (Hidden for now) */}
        <div className="absolute bottom-[-90px] left-0 sm:left-[-35px] border rounded-3xl h-[20vh] w-[20vh] sm:h-[25vh] sm:w-[25vh] bg-white text-center shadow-lg p-5 invisible">
          <div className="flex flex-col items-center space-y-4">
            <div className="border-8 border-red-200 rounded-full p-4">
              <VscDebugStart className="text-2xl text-red-500" />
            </div>
            <p className="text-lg sm:text-xl text-black font-semibold">
              Intro Video
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
